<div id="container">
  <app-navbar></app-navbar>
  <!-- <app-careers></app-careers> -->
  <router-outlet (activate)="onActive()"></router-outlet>
  <app-footer></app-footer>


  <!-- Go To Top Link -->
  <a href="#" class="back-to-top">
    <i class="fa fa-angle-up"></i>
  </a>

  <!-- Start Loader -->
  <div id="loader">
    <div class="square-spin">
      <div></div>
    </div>
  </div>
</div>